import { AnimatePresence, motion } from 'motion/react';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionHomeIndustriesImageProps extends PropsWithChildren {
  className?: string;
  currentIndex: number;
  onClick?: () => void;
}

export const MotionHomeIndustriesImage = ({
  children,
  className,
  currentIndex,
  onClick,
  ...props
}: MotionHomeIndustriesImageProps) => {
  return (
    <AnimatePresence mode="wait">
      <MotionHomeIndustriesImageWrapper
        {...props}
        onClick={onClick}
        className={className}
        key={currentIndex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: ANIMATION_CONFIG.industriesImage.duration,
          ease: 'easeInOut',
        }}
      >
        {children}
      </MotionHomeIndustriesImageWrapper>
    </AnimatePresence>
  );
};

const MotionHomeIndustriesImageWrapper = styled(motion.div)``;
